module.exports = __webpack_public_path__ + "static/media/map_marker.89d54611.png";